// extracted by mini-css-extract-plugin
export default {"listContainer":"t1zfO8u1ePQrvAhhpmvo","list":"A2MMspIjobRwcGydWJSR","listTitle":"u7taOK6tj56k94KNO81g"};